export const fullValidations = (
  validateName: boolean,
  validateCpf: boolean,
  validateEmail: boolean,
  validatePhone: boolean,
  isVerify: boolean
): boolean => {
  if (validateName && validateCpf && validateEmail && validatePhone && isVerify) {
    return false
  } else {
    return true
  }
}
